module.exports = __webpack_public_path__ + "img/film_b.c7b1b88c.svg";